import { request } from './http';

export async function getInboxNotifications(limit = 20) {
    return request(`/notifications/inbox?limit=${limit}`);
  }

export async function getInboxUnreadCount() {
    return request('/notifications/inbox/unread-count');
  }

export async function markInboxNotificationRead(id) {
    return request(`/notifications/inbox/${id}/read`, {
      method: 'PUT',
      body: JSON.stringify({})
    });
  }

export async function markAllInboxNotificationsRead() {
    return request('/notifications/inbox/read-all', {
      method: 'PUT',
      body: JSON.stringify({})
    });
  }

export async function getNotificationHistory(userId = null, limit = 50) {
    const endpoint = userId ? `/notifications/history/${userId}` : '/notifications/history';
    return request(`${endpoint}?limit=${limit}`);
  }

export async function sendTestEmail(to, subject, message, isHtml = true) {
    return request('/notifications/send-test-email', {
      method: 'POST',
      body: JSON.stringify({ to, subject, message, isHtml }),
    });
  }

export async function testDailyComplianceAlerts(testEmail = 'bobby@oneblueox.com') {
    return request('/notifications/test-daily-compliance-alerts', {
      method: 'POST',
      body: JSON.stringify({ testEmail }),
    });
  }

export async function deleteComplianceRecord(recordId) {
    return request(`/compliance/${recordId}`, {
      method: 'DELETE',
    });
  }

export async function sendCustomNotification(notificationData) {
    return request('/notifications/send-custom', {
      method: 'POST',
      body: JSON.stringify(notificationData),
    });
  }

export async function checkDueTasks(daysAhead = 7) {
    return request('/notifications/check-due-tasks', {
      method: 'POST',
      body: JSON.stringify({ daysAhead }),
    });
  }

export async function checkDuePermitTasks(daysAhead = 7) {
    return request('/notifications/check-due-permit-tasks', {
      method: 'POST',
      body: JSON.stringify({ daysAhead }),
    });
  }

export async function checkCompliance() {
    return request('/notifications/check-compliance', {
      method: 'POST',
    });
  }

export const emailAndNotificationsApi = {
  getInboxNotifications,
  getInboxUnreadCount,
  markInboxNotificationRead,
  markAllInboxNotificationsRead,
  getNotificationHistory,
  sendTestEmail,
  testDailyComplianceAlerts,
  deleteComplianceRecord,
  sendCustomNotification,
  checkDueTasks,
  checkDuePermitTasks,
  checkCompliance,
};

